<template>
  <v-sheet
    :class="$style.pageDialogWrapper"
    data-testid="pageDialogWrapper"
    :elevation="24"
  >
    <div :class="$style.headerWrapper">
      <slot name="header"></slot>
    </div>
    <div :class="$style.mainWrapper">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" :class="$style.footerWrapper">
      <slot name="footer"></slot>
    </div>
  </v-sheet>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.pageDialogWrapper {
  line-height: 1.4;
  background-color: colors.$color-white;
  padding: 28px variables.$pageDialogWindowPaddingX variables.$pageDialogWindowPaddingX variables.$pageDialogWindowPaddingX;
  overflow-y: visible !important;
}
  .headerWrapper {
  }
  .mainWrapper {
    margin-top: variables.$pageDialogWindowMainWrapperMargin;
  }
  .footerWrapper {
    margin-top: variables.$pageDialogWindowPaddingX;
  }
</style>
